export default __webpack_public_path__ + "static/media/2508115.0c7aa37a.png";